var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.shouldShowBackdrop)?_c('span',{staticClass:"breakdance-inline-editor-backdrop",style:(_vm.style),on:{"click":_vm.onBackdropClick}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }